import { memo, useCallback } from 'react';

import { PublicAudioCodingsSelect } from '~/components/Filters/AudioCodingFilter/components/PublicAudioCodingsSelect';
import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { StringArrayFilterCard, type StringArrayFilterCardProps } from '~/components/Filters/StringArrayFilterCard';

type PublicAudioCodingFilterCardProps = {
  boardId: string | undefined;
} & BaseFilterCardProps;

export const PublicAudioCodingFilterCard = memo(({ boardId, ...props }: PublicAudioCodingFilterCardProps) => {
  const renderAudioCodingsSelect = useCallback<StringArrayFilterCardProps['StringSelect']>(
    (props) => <PublicAudioCodingsSelect boardId={boardId} {...props} />,
    [boardId],
  );

  return (
    <StringArrayFilterCard
      filter="audioCodings"
      filterCardType="audioCoding"
      StringSelect={renderAudioCodingsSelect}
      {...props}
    />
  );
});

PublicAudioCodingFilterCard.displayName = 'PublicAudioCodingFilterCard';
